import { __rest } from "tslib";
import { create } from 'zustand';
export const useStatusStore = create((set, get) => ({
    storeMap: new Map(),
    statuses: {},
    setStatus: (store, status) => {
        set(state => {
            let identifier = state.storeMap.get(store);
            if (status === 'unset') {
                // Remove the store and its status if status is 'unset'
                if (identifier) {
                    const newMap = new Map(state.storeMap);
                    newMap.delete(store);
                    const _a = state.statuses, _b = identifier, _ = _a[_b], newStatuses = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]); // Omit the unset status
                    return { storeMap: newMap, statuses: newStatuses };
                }
                return {}; // If no identifier, no change needed
            }
            else {
                // Assign a new unique identifier if the store does not have one
                if (!identifier) {
                    identifier = `store-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
                    state.storeMap.set(store, identifier);
                }
                // Set or update the status
                return {
                    storeMap: state.storeMap,
                    statuses: Object.assign(Object.assign({}, state.statuses), { [identifier]: status })
                };
            }
        });
    },
    getStatus: (store) => {
        const identifier = get().storeMap.get(store);
        return identifier ? get().statuses[identifier] : undefined;
    }
}));
//# sourceMappingURL=status-store.js.map